<app-error-component
  [errorCode]="errorCode"
  [errorTitle]="errorTitle"
  [errorDescription]="errorDescription"
  [quickTip]="quickTip"
></app-error-component>
